import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaLock } from 'react-icons/fa';
import { INK } from 'Utils/styleTokens';

/**
 * Client-side route guard for admin-only pages (/admin, /integrations, /cloud-accounts).
 *
 * This is defense-in-depth and UX only — the platform API already enforces admin
 * authorization server-side (those write endpoints return 403 for non-admin JWTs).
 * Without this guard a non-admin who navigates directly to an admin URL renders the
 * full page with live write controls that would only fail on use; the nav links are
 * already hidden for non-admins, but routing did not enforce anything.
 */
function RequireAdmin({ isAdmin, children }) {
  if (isAdmin) return children;
  return (
    <Container className='mt-5'>
      <Row className='justify-content-center'>
        <Col md='6' className='text-center'>
          <FaLock size='2.5rem' color={INK[400]} className='mb-3' />
          <h4>You don&apos;t have access to this page</h4>
          <p className='text-muted'>
            This area is restricted to administrators. If you believe you should have
            access, contact your platform administrator.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default RequireAdmin;
